import { apiRequest } from './apiClient';

export async function fetchInvitations() {
  try {
    const data = await apiRequest('/api/invitations', { method: 'GET' });
    return { data, error: null };
  } catch (error) {
    return { data: [], error };
  }
}

export async function fetchInvitation(id) {
  try {
    const data = await apiRequest(`/api/invitations/${id}`, { method: 'GET' });
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

export async function createInvitation(invitationData) {
  try {
    const data = await apiRequest('/api/invitations', {
      method: 'POST',
      body: JSON.stringify(toBackendInvitation(invitationData)),
    });
    return { data: data.invitation, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

export async function updateInvitation(id, updates) {
  try {
    const data = await apiRequest(`/api/invitations/${id}`, {
      method: 'PUT',
      body: JSON.stringify(toBackendInvitation(updates)),
    });
    return { data: data.invitation, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

export async function deleteInvitation(id) {
  try {
    await apiRequest(`/api/invitations/${id}`, { method: 'DELETE' });
    return { error: null };
  } catch (error) {
    return { error };
  }
}

export async function toggleFavorite(id) {
  try {
    const data = await apiRequest(`/api/invitations/${id}/favorite`, { method: 'PATCH' });
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

export async function updateTags(id, tags) {
  try {
    const data = await apiRequest(`/api/invitations/${id}/tags`, {
      method: 'PATCH',
      body: JSON.stringify({ tags }),
    });
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

export async function fetchInvitationVersions(invitationId) {
  try {
    const data = await apiRequest(`/api/invitations/${invitationId}/versions`, { method: 'GET' });
    return { data, error: null };
  } catch (error) {
    return { data: [], error };
  }
}

export async function createInvitationVersion(invitationId, payload) {
  try {
    const data = await apiRequest(`/api/invitations/${invitationId}/versions`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

export async function generateInvitation(payload) {
  return apiRequest('/api/generate-invitation', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function refineInvitation(payload) {
  return apiRequest('/api/refine-invitation', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function importLocalStorageInvitations(localInvitations) {
  const results = { imported: 0, errors: [] };

  for (const invitation of localInvitations || []) {
    const { error } = await createInvitation(invitation);
    if (error) {
      results.errors.push({ id: invitation.id, error: error.message });
    } else {
      results.imported += 1;
    }
  }

  return results;
}

export function mapDbToFrontend(invitation) {
  if (!invitation) {
    return null;
  }

  return {
    ...invitation,
    id: invitation.invitation_id || invitation.id,
    invitation_id: invitation.invitation_id || invitation.id,
    _db: 'mongo',
    final_invitation_json: invitation.final_invitation_json || null,
    generatedDesign: invitation.final_invitation_json || null,
    ai_enabled: Boolean(invitation.ai_enabled),
  };
}

function toBackendInvitation(invitationData) {
  return {
    couple_names: invitationData.couple_names || { name1: '', name2: '' },
    date: invitationData.date || null,
    time: invitationData.time || null,
    time_of_day: invitationData.time_of_day || null,
    location: invitationData.location || null,
    city_country: invitationData.city_country || invitationData.location || null,
    event_type: invitationData.event_type || 'Wedding',
    dress_code: invitationData.dress_code || null,
    style: invitationData.style || 'Romantic Classic',
    tone: invitationData.tone || 'Romantic',
    theme: invitationData.theme || null,
    cultural_influence: invitationData.cultural_influence || null,
    desired_length: invitationData.desired_length || 'medium',
    color_preferences: invitationData.color_preferences || [],
    style_preferences: invitationData.style_preferences || [],
    audience_style: invitationData.audience_style || null,
    context_scene: invitationData.context_scene || null,
    extra_notes: invitationData.extra_notes || null,
    favorite: Boolean(invitationData.favorite),
    tags: invitationData.tags || [],
    ai_enabled: Boolean(invitationData.ai_enabled),
    original_inputs: invitationData.original_inputs || null,
    selected_version_id: invitationData.selected_version_id || null,
    final_invitation_json: invitationData.final_invitation_json || invitationData.generatedDesign || null,
    refinement_history: invitationData.refinement_history || [],
  };
}
